import axios from 'axios';
import { GateOutGetAllQuery, IdProps } from '../../types';
import { TABLE } from '../../const';
import { extendContainerValidator, toIsoDate } from '../../utils';

class GateOutsService {
  add = async (props: any) => axios.post('/gate-outs', props);

  createFilter = (props: any) => axios.post('/gate-outs/filter', props);

  createByFilter = ({ id, containerIds }: any) =>
    axios.post(`/gate-outs/filter/${id}`, containerIds);

  getAll = (props: any) => axios.get<GateOutGetAllQuery>('/gate-outs', props);

  getAllPreFormatProps = (props: any) => {
    const keys = props.params;

    if (keys.containerNumber?.length < 3 || !extendContainerValidator(keys.containerNumber))
      delete keys.containerNumber;
    if (keys.startDate) keys.startDate = toIsoDate(keys.startDate, true);
    if (keys.endDate) keys.endDate = toIsoDate(keys.endDate, true);

    return axios.get<GateOutGetAllQuery>('/gate-outs', props);
  };

  getLicensePlateNumber = (props: any) => async () => {
    if (props.params.licensePlateNumber?.length < 3) delete props.params.licensePlateNumber;

    const data = await axios
      .get('/gate-outs/license-plate-number', {
        params: { ...props.params, notLoading: true, take: TABLE.PAGE_MAX_SIZE, skip: 0 },
      })
      .then((res) => res.data.data);

    return data;
  };

  get = (id: any) => axios.get(`/gate-outs/${id}`);

  filterLoadingAllowed = (id: string) => axios.patch(`/gate-outs/filter/${id}/loading-allowed`);

  loadingAllowed = (props: IdProps[]) => axios.patch('/gate-outs/loading-allowed', props);

  extendDate = ({ ids, validTo }: any) =>
    axios.patch(
      `/gate-outs/extend-date`,
      ids.map((id: string) => ({ id })),
      {
        params: { validTo },
      },
    );

  loaded = ({ id, props }: any) => axios.patch(`/gate-outs/${id}/loaded`, props);

  complete = ({ id, props }: any) => axios.patch(`/gate-outs/${id}`, props);

  delete = (props: IdProps[]) => axios.delete('/gate-outs', { data: props });

  deleteByFilter = (id: any) => axios.delete(`/gate-outs/filter/${id}`);
}

export const gateOutsService = new GateOutsService();
